export default __webpack_public_path__ + "static/media/cover_2.5c549ca4.jpg";